import React, { useEffect } from 'react';
import { BasicSearch } from './BasicSearch';
import { useSearchBarContext } from './Context/SearchBarContext';
import { useExplorerSearch } from './hooks/useExplorerSearch';
import { useLiveSearch } from './hooks/useLiveSearch';
import SearchService from 'business/services/SearchService';

export const SearchBar = () => {
  const { filters, updateRecentResults } = useSearchBarContext();

  useEffect(() => {
    const searchService = new SearchService();
    searchService
      .GetRecentSearches()
      .then(updateRecentResults)
      .catch(() => {});
  }, []);

  useLiveSearch();
  const { handleSearch } = useExplorerSearch();

  return (
    <div id="search-bar-wrapper">
      <BasicSearch onSearch={() => handleSearch(filters)} />
    </div>
  );
};
